export default __webpack_public_path__ + "static/media/correct.662e1966.svg";